<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
<p class="Part-number"><span class="part-number _idGenCharOverride-2">Part I</span></p>
<p class="Part-title">Class Struggle in <span class="Part-title _idGenCharOverride-3">the</span> <br/>“Land of Opportunity,” 1865–1930 </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?245b5b90